const createVoucherIT = {
    key: 'Chiave',
    productId: 'ID prodotto',
    variantId: 'ID variante',
    licenseId: 'ID licenza',
    maxSessions: 'Utilizzo massimo',
    generate: 'Generare la chiave'
}

export default createVoucherIT